'use client';

import { useDirectSaleOffersControllerGetAllDirectSaleOffers } from '~/lib/api';

import { DirectSaleOfferCard } from './direct-sale-offer-card';
import { SectionTitleSeparator } from './section-title-separator';

export const DirectSaleOffersSection = () => {
  const { data, isLoading } = useDirectSaleOffersControllerGetAllDirectSaleOffers({
    excludeArchived: true,
  });

  const offers = data?.data.offers ?? [];

  if (isLoading) {
    return null;
  }

  if (offers.length === 0) {
    return null;
  }

  return (
    <div className="mt-12">
      <SectionTitleSeparator />
      <div className="flex flex-col gap-8">
        {offers.map((offer) => (
          <DirectSaleOfferCard key={offer.id} offer={offer} />
        ))}
      </div>
    </div>
  );
};
